import {MessageDescriptor} from 'react-intl';
import {ReactNode} from 'react';

import {ViewMode} from '@stripe-internal/support-conversations-controller';

import {StripeAssistantDrawerHeader} from './StripeAssistantDrawerHeader';
import {StripeAssistantWidgetHeader} from './StripeAssistantWidgetHeader';
import {useViewMode} from '../../../core/hooks/appHooks';

type Props = {
  title?: MessageDescriptor;
  height?: number | string;
  badge?: ReactNode;
  headerActions?: ReactNode;
  subHeader?: ReactNode;
};

export function StripeAssistantHeader(props: Props) {
  const viewMode = useViewMode();

  if (viewMode === ViewMode.Drawer) {
    return <StripeAssistantDrawerHeader {...props} />;
  }

  return <StripeAssistantWidgetHeader {...props} />;
}
